import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { FormControl } from 'react-bootstrap'
import { toNumber } from 'lodash'
import { connectedInputUpdate } from '../../redux/forms-reducer'

export const INPUT_TYPE_NUMBER = 'number'
export const STORE_FORMAT_PERCENT = 'store-percent'

/**
 * This smart component connects the value of a react-boostrap FormControl
 * to the redux store and manages the updating of the store on change.
 */
export class ConnectedInput extends Component {
  /**
   * C'tor
   * @param props
   */
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  /**
   * Key press in the input event
   * @param event
   */
  handleChange (event) {
    let val = event.target.value
    if (this.props.type === INPUT_TYPE_NUMBER) {
      // safari doesn't handle this without sending the event like chrome does
      if (!event.target.validity.valid) {
        event.preventDefault()
        return
      }
      val = toNumber(val)
    }
    if (
      this.props.storeFormat &&
      this.props.storeFormat === STORE_FORMAT_PERCENT
    ) {
      // safari doesn't handle this without sending the event like chrome does
      if (!event.target.validity.valid) {
        event.preventDefault()
        return
      }
      val = toNumber(val) / 100
    }
    this.props.dispatch(connectedInputUpdate(this.props.reduxKey, val))
  }

  /**
   * Render the component
   * @returns
   */
  render () {
    return (
      <FormControl
        style={this.props.formControlStyle}
        value={this.props.inputVal ? this.props.inputVal : ''}
        type={this.props.type}
        onChange={this.handleChange}
        className={'form-control-override'}
      />
    )
  }
}

ConnectedInput.propTypes = {
  reduxKey: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  formControlStyle: PropTypes.object,
  storeFormat: PropTypes.string
}

export function mapStateToProps (state, ownProps) {
  let val = state.get('forms').get(ownProps.reduxKey)
  if (ownProps.storeFormat && ownProps.storeFormat === STORE_FORMAT_PERCENT) {
    val = toNumber((val * 100).toFixed(2))
  }
  return {
    inputVal: val
  }
}

export default connect(mapStateToProps)(ConnectedInput)



// WEBPACK FOOTER //
// ./src/components/forms/ConnectedInput.js